import { SelectionPageContent } from "../../components/SelectionPageContent";
import './LevelSelection.css';

export const LevelSelection = (props:any) => {
  const parentNode = 'LEVEL_SELECTION';
  const { goToPrevPage, goToNextPage } = props;

  return (
    <SelectionPageContent
      parentNode={parentNode}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
    />
  )
};
